import { render, staticRenderFns } from "./UpdateShippingMethodAndOrderType.vue?vue&type=template&id=4be405e0"
import script from "./UpdateShippingMethodAndOrderType.vue?vue&type=script&lang=js"
export * from "./UpdateShippingMethodAndOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports